<p-toast
    [key]="toastKey"
    position="top-center" />
<router-outlet />
